// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__2poTw","title":"Info_title__MXMG6","links":"Info_links__2kIMi","link":"Info_link__77SYW","logo":"Info_logo__2-9Zg"};